<template>
  <div>
    <DaiBarrasApiladas
      :barras_apiladas_id="'bar-apiladas-animadas'"
      :datos="data_barras"
      :nombre_barra="'tamanio'"
      :nombre_color="'cantidad'"
      :variables='[{"id":"cantidad","nombre":"Cantidad","color":"#1995FC"}]'
      :ancho_tooltip="180"
      :valor_maximo_y="valor_maximo_y"
      :alto_vis="250"
      :titulo_eje_x ="'Cantidad de participantes por conglomerado'"
      :titulo_eje_y ="'Cantidad de conglomerados'"
      ref='bar-apiladas-animadas'
      class="contenedor-grafica flex-1"
      :espaciado_barras=".1"
      :textoTooltip="textoTooltip"
      :margen="margen_barras_animadas"
    >
    <template slot="encabezado">
      <div class="encabezado">
        <h5 class="titulo-visualizacion">Distribución de participantes por conglomerado en el tiempo</h5>
        <p class="fecha-actualizacion" >{{fecha_actualizacion}}</p>
      </div>
    </template>
    <template slot="pie">
      <div class="pie">
        <div class="contenedor-reproductor">
          <div class="reproductor">
            <div class="controles">
              <button class="btn play" @click="toggle_play">
                <!--{{reproductor_is_play ? 'pausa' : 'play' }} -->
                <img v-if="!reproductor_is_play" src="@/assets/img/play.svg" alt="">
                <img v-if="reproductor_is_play" src="@/assets/img/pause.svg" alt="">
              </button>
            </div>
            <div class="historico">
              <output for="slider-reproductor"
                class="tooltip-reproductor"
                :style="{ left :`calc(${(valor_actual/(arrange_fechas.length-1))*100}% + ${((valor_actual/(arrange_fechas.length-1)*2)-1)*-11}px`}"
              >
                <span>
                  {{formatearFecha(data_conglomerados[valor_actual].fecha)}}
                </span>
              </output>
              <input class="slider-reproductor"
                type="range"
                min="0"
                :max="arrange_fechas.length - 1"
                step="1"
                @change="cambioSlider"
                v-model="valor_actual"
              >
              <div class="fecha">
                <div class="item first-date">{{formatearFecha(data_conglomerados[indice_min].fecha)}}</div>
                <div class="item last-date">{{formatearFecha(data_conglomerados[indice_max].fecha)}}</div>
              </div>
            </div>
          </div>
          <p class="nota"></p>
        </div>
        <PieComponenteLibreria />
      </div>
    </template>
    </DaiBarrasApiladas>
  </div>
</template>
<script>
import * as d3 from "d3";
import DaiBarrasApiladas from '@/components/graficas/BarrasApiladasAnim.vue';
import PieComponenteLibreria from '@/components/base/PieComponenteLibreria.vue';
import data_conglomerados from "@/assets/data/vih_conglomerado_tiempo.json";

import { mapState } from "vuex";

var lista_meses = [
	"Enero",
	"Febrero",
	"Marzo",
	"Abril",
	"Mayo",
	"Junio",
	"Julio",
	"Agosto",
	"Septiembre",
	"Octubre",
	"Noviembre",
	"Diciembre",
]
var lista_meses_min = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
]
var lista_meses_abr = [
	"ene",
	"feb",
	"mar",
	"abr",
	"may",
	"jun",
	"jul",
	"ago",
	"sep",
	"oct",
	"nov",
	"dic",
]
export default {
	name: 'DistribucionAnimada',
    components: {
        DaiBarrasApiladas,
        PieComponenteLibreria,
    },
    data(){
        return {
            arrange_fechas: Object.keys(data_conglomerados).map(d=>+d),
            indice_min: d3.min(Object.keys(data_conglomerados).map(d=>+d)),
            indice_max: d3.max(Object.keys(data_conglomerados).map(d=>+d)),
            data_conglomerados: data_conglomerados,
            data_barras : data_conglomerados[data_conglomerados.length - 1].distribucion,
            valor_maximo_y: d3.max(Object.values(data_conglomerados).map(d=>d.distribucion[0].cantidad)),
            valor_actual:data_conglomerados.length - 1,
            current_frame:0,
            periodo_dias_frame:14,
            delay: 200,
            reproductor_is_play: false,
            repeat: false,
            margen_barras_animadas: {arriba: 10, abajo: 20, izquierda: 30, derecha: 30}
        }
    },
    mounted(){
        this.reescalandoPantalla()
        window.addEventListener("resize", this.reescalandoPantalla);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.reescalandoPantalla);

    },
    methods: {
      reescalandoPantalla(){

		if(window.innerWidth < 450){
			this.margen_barras_animadas = {arriba: 10, abajo: 40, izquierda: 30, derecha: 30};
			setTimeout(()=>{
				this.$refs["bar-apiladas-animadas"].eje_x.selectAll("text").attr("transform","rotate(-90)translate(-8,-12)").style("text-anchor","end");
			},200)	
		}
		else{

			this.margen_barras_animadas = {arriba: 10, abajo: 20, izquierda: 30, derecha: 30}
			setTimeout(()=>{
				
				this.$refs["bar-apiladas-animadas"].eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle")
				
				},200)
			}
			
    },
        reproducir(){
            if(this.valor_actual + 1 == this.arrange_fechas.length){
                this.valor_actual = 0;
            }
            this.pasos = setInterval(()=>{

                const new_step = (this.valor_actual + 1) < this.arrange_fechas.length ? this.valor_actual+1 : ( this.repeat ? 0 : -1 )
                if(new_step>-1){
                    this.valor_actual = new_step
                }else{
                    this.pausar()
                    this.reproductor_is_play = false;
                }
            },
            this.delay)
        },
        textoTooltip(){
            var txt = []
            this.$refs["bar-apiladas-animadas"].variables.map((d)=>{
                txt.push(  `
                <p>Fecha: ${this.formatearFecha(this.data_conglomerados[this.valor_actual].fecha)}</p>
                <p><span class="nomenclatura-tooltip" style="background: ${d.color}"></span>
                Cantidad de conglomerados con ${this.$refs["bar-apiladas-animadas"].tooltip_data_seleccionada.tamanio} nodos: <b>${this.$refs["bar-apiladas-animadas"].tooltip_data_seleccionada[d.id].toLocaleString("en")}</b>
                </p>` )
            })

            return txt.reverse().join(" ")

        },
        pausar(){
            window.clearInterval(this.pasos)
        },
        cambioSlider: function(event){
            this.valor_actual = parseInt(event.target.value);
            this.reproductor_is_play = false

            this.pausar()
        },
        toggle_play: function(){
            this.reproductor_is_play = !this.reproductor_is_play
        },
        formatearFecha(fech){
            let txt = fech.split("-")
            return `${lista_meses_min[parseInt(txt[1])-1]}/${txt[2]}`
        }

    },
    watch:{
        reproductor_is_play (newValue){
            if(newValue){
                this.reproducir()
            }else{
                this.pausar()
            }
        },
        valor_actual(nv){
            this.data_barras = data_conglomerados[nv].distribucion;
        }
    },
    computed: {
      ...mapState({
        fecha_actualizacion: state => `Última Actualización: ${state['fechaActualizacion']}`
      }),
    },
}

</script>

<style lang="scss" scoped>
div#porcentaje-pacientes-por-tiempo::v-deep, div#numero-conglomerados-por-tiempo::v-deep {
    div.tooltip{
      div.tooltip-cuerpo{
      font-size: 12px;
        p{
          margin: 0;
        }
        ul.tooltip-lineas{
          margin: 0;
          padding: 5px 0 0 0;
          li{
            list-style: none;
            margin: 0 0 5px 0;
            font-size: 12px;
            &::before {
              background: transparent;
            }
            span.span-tooltip-color {
              transform: translateY(2px);
              width: 12px;
              height: 12px;
				border: solid 1px rgba(255, 255, 255, .7 );
              display: inline-block;
              border-radius: 50%;
            }
          }
        }
      }
    }

  }
div.contenedor-grafica{
    margin: 24px 0;
    background: #fff;
	width: 100%;
    border: solid black 1px;
    border-radius: 10px;
    position: relative;
    div.encabezado{
        .titulo-proyecto {
            padding: 10px 10px 0px 10px;
            text-align: right;
            font-size: 12px;
            display: inherit;
        }
        .titulo-visualizacion {
                font-size: 16px;
                padding: 10px 10px 0;
                margin: 0;
        }
        .fecha-actualizacion {
                font-size: 12px;
                padding: 0 10px;
                margin: 5px 0;
        }
        .instruccional {
                font-size: 12px;
                padding: 0 10px;
                margin: 5px 0;
        }
    }
    .pie{
      box-shadow: 0px -5px 5px -1px rgb(221, 221, 221);
      border-radius: 15px;
        .contenedor-reproductor{
            padding: 20px 50px;
            @media (max-width: map-get($media-queries-limit, "mobile")) {
              padding: 20px 20px;
          }
        }
    }


}
</style>
